module.exports = __webpack_public_path__ + "media/images/accord-majeur-56f461e1de6535aac4e9efc591277983.png";